import React, { useEffect } from 'react'
import cognitoUtils from '../../utils/cognitoUtils';

/**
 * Componente para la página de login.
 * 
 * @returns {React.Component}
 */
export default function Login() {

    useEffect(() => {
        window.location.href = cognitoUtils.getCognitoSignInUri();
    }, [])

    return <></>
}